<div class="gpd-config-section">
  <div class="gpd-config-section-header">
    <div>
      <div class="gpd-config-section-title">
        <span i18n="@@areaTypes">Area Types</span>
      </div>
      <div class="gpd-config-section-description" i18n="@@areaTypeConfigDescription">Define area types</div>
    </div>
    <app-gpd-button i18n-text="@@add" text="Add" icon="add" (onClick)="onAdd()" [disabled]="editData"></app-gpd-button>
  </div>
  <div class="section-form" *ngIf="editData">
    <dx-form #form class="gpd-form" [colCount]="2">
      <dxi-item [colSpan]="1" dataField="name">
        <dxo-label i18n-text="@@name" text="Name"></dxo-label>
        <dx-text-box class="gpd-input" [(value)]="editData.name" valueChangeEvent="input">
          <dx-validator>
            <dxi-validation-rule type="required" i18n-message="@@required" message="Required"></dxi-validation-rule>
            <dxi-validation-rule type="custom" [validationCallback]="validateUniqueName" i18n-message="@@nameAlreadyExists" message="Name already exists" [reevaluate]="true"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </dxi-item>
      <dxi-item [colSpan]="1" dataField="tasks" [visible]="!editData.id">
        <dxo-label i18n-text="@@areaTypeExistingTasks" text="Add existing tasks"></dxo-label>
        <dx-drop-down-box
          class="gpd-input"
          [value]="selectedTaskNodeIds"
          [dataSource]="configTree"
          displayExpr="title"
          valueExpr="nodeId"
        >
          <div *dxTemplate="let data of 'content'">
            <dx-tree-view
              [items]="configTree"
              dataStructure="plain"
              keyExpr="nodeId"
              parentIdExpr="parentNodeId"
              displayExpr="title"
              searchExpr="title"
              searchMode="contains"
              [searchEnabled]="true"
              selectionMode="multiple"
              showCheckBoxesMode="normal"
              [selectNodesRecursive]="true"
              [selectByClick]="true"
              (onContentReady)="onTaskTreeReady($event)"
              (onItemSelectionChanged)="onTaskSelectionChanged($event)"
            >
            </dx-tree-view>
          </div>
        </dx-drop-down-box>
      </dxi-item>
      <dxi-item [colSpan]="1" dataField="sizeTask">
        <dxo-label i18n-text="@@areaTypeSizeTask" text="Size task"></dxo-label>
        <dx-select-box
          class="gpd-input"
          [items]="sizeTaskOptions"
          valueExpr="id"
          displayExpr="label"
          [searchEnabled]="true"
          [showClearButton]="true"
          [(value)]="editData.sizeTaskConfigId"
        ></dx-select-box>
      </dxi-item>
      <dxi-item [colSpan]="1" dataField="sizeUnit">
        <dxo-label i18n-text="@@areaTypeSizeUnit" text="Unit"></dxo-label>
        <dx-text-box class="gpd-input" [(value)]="editData.sizeUnit" [maxLength]="20" valueChangeEvent="input"></dx-text-box>
      </dxi-item>
      <dxi-item [colSpan]="2" dataField="buttons">
        <dxo-label [visible]="false"></dxo-label>
        <div class="section-form-buttons gpd-button-group">
          <app-gpd-button i18n-text="@@cancel" text="Cancel" icon="cancel" (onClick)="onCancel()" type="secondary"></app-gpd-button>
          <app-gpd-button i18n-text="@@save" text="Save" icon="tick" (onClick)="$event.validationGroup.validate().isValid && onSave($event)"></app-gpd-button>
        </div>
      </dxi-item>
    </dx-form>
  </div>
  <div class="gpd-config-section-content" *ngIf="areaTypes.length > 0 && !editData">
    <dx-data-grid
      #dgrid
      [dataSource]="areaTypes || []"
      class="gpd-datagrid"
      width="100%"
      [showBorders]="true"
      [allowColumnResizing]="true"
      [columnAutoWidth]="true"
      [columnHidingEnabled]="true"
      [allowColumnReordering]="true"
    >
      <dxi-column dataField="name" i18n-caption="@@name" caption="Name"></dxi-column>
      <dxi-column dataField="sizeUnit" i18n-caption="@@areaTypeSizeUnit" caption="Unit"></dxi-column>
      <dxi-column
        dataField=""
        allowEditing="false"
        cellTemplate="buttonCellTemplate"
        [width]="100"
        [formItem]="{ visible: false }"
      >
        <div *dxTemplate="let item of 'buttonCellTemplate'">
          <div class="gpd-table-actions">
            <app-svg-icon
              icon="edit"
              color="var(--color-primary)"
              [strokeWidth]="1.5"
              [size]="20"
              class="gpd-button-icon"
              (click)="onEdit(item.data)"
            ></app-svg-icon>
            <app-svg-icon
              icon="delete"
              color="var(--color-red-500)"
              [strokeWidth]="1.5"
              [size]="20"
              class="gpd-button-icon"
              (click)="deleteAreaType(item.data)"
            ></app-svg-icon>
          </div>
        </div>
      </dxi-column>
    </dx-data-grid>
  </div>
</div>
